import React, { useEffect, useState } from "react";
import "./Support.css"; // Optional: For adding styles
import { Col, Row } from "reactstrap";
import logo from "../../../Assets/image/logo.png";
import Footer from "../footer/footer";
import Supporti from "../../../Assets/image/jpg png/suuppor11t.webp";
import Shape from "../../../Assets/image/jpg png/444 SHAPE.webp";
import Images from "../../../Assets/image/jpg png/images_11zon.webp";
import Conversation from "../../../Assets/image/jpg png/conversation (1).png";
import Monitaring from "../../../Assets/image/jpg png/maintenance.png";
import Services from "../../../Assets/image/jpg png/Services.webp";
import Presentation from "../../../Assets/image/jpg png/presentation.png";
import Bar1 from "../../../components/navigationbar/navigationbar1";
import RevealBlurFX from "../../../components/Effect/RevealBlurFX";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const Support = () => {

    const [isVisible, setIsVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);

    const handleScroll = () => {
        const currentScrollY = window.scrollY;

        if (currentScrollY > lastScrollY) {
            // Scrolling down
            setIsVisible(false);
        } else {
            // Scrolling up
            setIsVisible(true);
        }

        setLastScrollY(currentScrollY);
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [lastScrollY]);


    return (
        <>
            <Helmet>
                <title>Technical Support & Troubleshooting | Sandip electronics  and Automation</title>
                <meta name="description" content="Get expert technical support for solar pump controllers, ATS, and industrial automation. Download manuals, troubleshoot error codes, and contact our Pune service team." />
                <meta name="keywords" content="solar pump controller troubleshooting, ATS technical support, automation repair  Pune(India), Sandip electronics  manual, pump controller error codes" />
                <meta property="og:title" content="Support Center: Sandip electronics  and Automation" />
                <meta property="og:description" content="Facing a technical issue? Our support team is here to help with wiring diagrams, manuals, and expert troubleshooting tips." />
                <meta property="og:image" content="https://seaiot.in/images/support-hero.jpg" />
                <meta property="og:url" content="https://seaiot.in/support" />
                <meta property="og:type" content="website" />
            </Helmet>

            <div>
                <div className={`AppA ${isVisible ? "visible" : "hidden"}`}>
                    <div className="mylogo">
                        <div className="logo-container">
                            <Link to="/" className="cursor-pointer">
                                <img src={logo} alt="Logo" />
                            </Link>
                        </div>
                    </div>
                    <div className="bar-container">
                        <Bar1 />
                    </div>
                </div>

                <div className="support">
                    <div className="supportimg">
                        <img src={Supporti} alt="slogo" name="slogo" style={{ height: '100%', width: '550px' }} />
                    </div>
                    <div className="supportmain">
                        <RevealBlurFX>
                            <div className="supporttext">
                                <h1>Always Here to Help!</h1>
                                <p className="mt-1">We prioritize seamless customer and vendor assistance with our Quick Support system.
                                    Whether you have queries, need troubleshooting, or require product guidance,
                                    our expert team is just a call or message away
                                </p>
                            </div>
                        </RevealBlurFX>
                        <div className="shape4">
                            <img src={Shape} alt="slogo" name="slogo" style={{ height: '100%', width: '650px' }} />
                        </div>
                    </div>


                    <div className="image-container">
                        <div className="supportimg2">
                            <img
                                src={Images}
                                alt="Images"
                                name="Images"
                                style={{ height: '100%', width: '600px', borderRadius: '90px' }}
                            />
                        </div>
                        <img
                            src={Services}
                            alt="Services"
                            name="Services"
                            className="overlay-image"
                        />
                    </div>
                    <RevealBlurFX>
                        <div className="supporttext2">
                            <h1>Services</h1>
                            <div className="p-2 ml-2 flex gap-5">
                                <div>
                                    <img src={Conversation} alt="Conversation" name="Conversation" />
                                </div>
                                <div>
                                    <h2 className="ml-1">
                                        Consulting
                                    </h2>
                                    <p className="ml-3">Offer consulting for custom power electronics  solutions, solar installation, and energy optimization.</p>
                                </div>
                            </div>
                            <hr />
                            <div className="p-2 ml-2 flex gap-5">
                                <div>
                                    <img src={Monitaring} alt="Monitaring" name="Monitaring" />
                                </div>
                                <div>
                                    <h2 className="ml-1">
                                        Installation and Maintenance
                                    </h2>
                                    <p className="ml-3">Detail services for the installation and ongoing maintenance of solar systems, water pumps, and other products.
                                    </p>
                                </div>
                            </div>
                            <hr />
                            <div className="p-2 ml-2 flex gap-5">
                                <div>
                                    <img src={Presentation} alt="Monitaring" name="Monitaring" />
                                </div>
                                <div>
                                    <h2 className="ml-1">Training and Support</h2>
                                    <p className="ml-3">Provide training for customers and technicians on how to operate and maintain products.</p>
                                    <p className="ml-3">Support via phone, email, and online resources.</p>
                                </div>
                            </div>
                        </div>
                    </RevealBlurFX>
                    <Footer />
                </div>
            </div>
        </>
    );
};

export default Support;

